import removeNotNumberFromString from './removeNotNumberFromString';

/**
 * 휴대폰 번호에 대한 형식지정 함수입니다.
 * 변환 형식 : '000-000-0000' 또는 '000-0000-0000'
 * @param {string} sourceString
 * @returns {string} 숫자외 다른 문자열은 제거하고 휴대폰번호 형식으로 문자열 형식을 조정합니다.
 */
export default function getFormattedSouthKoreaPhoneNumber(sourceString) {
  let regPhoneNum = '';
  let dataForm = '';
  let formattedPhoneNumber = sourceString;

  // return blank
  if (!sourceString) {
    return '';
  }

  // delete not number
  formattedPhoneNumber = removeNotNumberFromString(formattedPhoneNumber);

  /* 4자리 미만일 경우 위에서 숫자 외 다른문자 제거한 상태로 리턴. */
  if (formattedPhoneNumber.length < 4) {
    return formattedPhoneNumber;
  }

  // 11자리가 넘어가는 숫자는 제거한다.
  if (formattedPhoneNumber.length > 11) {
    formattedPhoneNumber = formattedPhoneNumber.substring(0, 11);
  }

  /**
   * 한국 지역 번호 형식으로 포맷팅
   * @see https://ko.wikipedia.org/wiki/대한민국의_전화번호_체계#지역_번호_(02,_0NZ)
   */
  if (formattedPhoneNumber.startsWith('02')) {
    if (formattedPhoneNumber.length < 6) {
      dataForm = '$1-$2';
      regPhoneNum = /([0-9]{2})([0-9]+)/;
    } else if (formattedPhoneNumber.length > 9) {
      dataForm = '$1-$2-$3';
      regPhoneNum = /([0-9]{2})([0-9]{4})([0-9]+)/;
    } else {
      dataForm = '$1-$2-$3';
      regPhoneNum = /([0-9]{2})([0-9]{3})([0-9]+)/;
    }
  } else if (formattedPhoneNumber.length < 7) {
    dataForm = '$1-$2';
    regPhoneNum = /([0-9]{3})([0-9]+)/;
  } else if (formattedPhoneNumber.length > 10) {
    dataForm = '$1-$2-$3';
    regPhoneNum = /([0-9]{3})([0-9]{4})([0-9]+)/;
  } else {
    dataForm = '$1-$2-$3';
    regPhoneNum = /([0-9]{3})([0-9]{3})([0-9]+)/;
  }

  return formattedPhoneNumber.replace(regPhoneNum, dataForm);
}
